import { Injectable } from "@angular/core";
import { captureException } from "@sentry/angular";

// extend window with dataLayer prop
declare global {
  interface Window {
    dataLayer: unknown[];
    mixpanel?: {
      track: (name: string, properties: unknown) => void;
    };
  }
}

interface TrackingProperties {
  event_action: string;
  event_label: string;
  event_type: string;
  event_value?: string;
  event_step?: string;
}

@Injectable({
  providedIn: "root"
})
export class TrackingService {
  trackEvent(
    eventCategory: string,
    properties: {
      event_action: string;
      event_label: string;
      event_type: string;
      event_value?: string;
      event_step?: string;
    }
  ) {
    this.retryTrackEvent(
      eventCategory,
      {
        ...properties
      },
      3
    );
  }

  private retryTrackEvent(eventCategory: string, trackingProperties: TrackingProperties, retryCount = 0) {
    if (retryCount <= 0) {
      captureException(
        `Failed to track mixpanel event after multiple attempts ${eventCategory} ${JSON.stringify(trackingProperties)}`
      );
      return;
    }

    try {
      window?.mixpanel?.track(eventCategory, trackingProperties);
    } catch (error) {
      setTimeout(() => this.retryTrackEvent(eventCategory, trackingProperties, retryCount - 1), 1000);
    }
  }
}
